/* global PIXI, TWEEN */

// eslint-disable-next-line no-unused-vars
const deg2rad = (deg) => (deg * Math.PI) / 180;
// eslint-disable-next-line no-unused-vars
const rand = (a, b) => (Math.random() * (b - a) + a);

const text = (t, size, color, x, y) => {
  const txt = new PIXI.Text(t, {
    fontFamily: 'Arial',
    fontSize: size,
    fill: color,
    align: 'center',
  });
  txt.x = x - txt.width / 2;
  txt.y = y - txt.height / 2;

  return txt;
};

// eslint-disable-next-line no-unused-vars
const circle = (color, size, txt, x, y) => {
  const c = new PIXI.Container();

  const g = new PIXI.Graphics();
  g.beginFill(color);
  g.drawCircle(0, 0, size);
  g.x = x;
  g.y = y;
  g.size = size;

  c.addChild(g);
  c.g = g;
  const t = text(txt, 24, 0xffffff, g.x, g.y);
  c.addChild(t);

  return c;
};

// eslint-disable-next-line no-unused-vars
const smallCircle = (color, size, theta, txt, bigSize, deltaX, deltaY, subX, subY, noFill, fontColor) => {
  const c = new PIXI.Container();

  // const margin = bigSize / rand(3, 18);
  const g = new PIXI.Graphics();
  if (noFill) {
    g.lineStyle(5, color, 1);
  } else {
    g.beginFill(color);
  }
  g.drawCircle(0, 0, size);
  g.x = deltaX + subX;
  g.y = deltaY + subY;
  g.originX = g.x;
  g.originY = g.y;
  // console.log(subX + deltaX);
  g.interactive = true;
  g.size = size;
  g.noFill = noFill;
  g.endFill();
  c.addChild(g);
  const t = text(txt, 16, fontColor, g.x, g.y);
  c.addChild(t);
  g.tween = null;
  t.alpha = 0;

  g.spread = () => {
    const coords = { x: g.x, y: g.y, alpha: t.alpha };
    if (g.tween) g.tween.stop();
    g.tween = new TWEEN.Tween(coords)
      .to({
        alpha: 1,
      }, 300)
      .onUpdate(() => {
        t.alpha = coords.alpha;
      })
      .start();
  };

  g.unspread = () => {
    const coords = { x: g.x, y: g.y, alpha: t.alpha };
    if (g.tween) g.tween.stop();
    g.tween = new TWEEN.Tween(coords)
      .to({
        alpha: 0,
      }, 300)
      .onUpdate(() => {
        t.alpha = coords.alpha;
      })
      .start();
  };

  g.mouseover = () => {
    g.spread();
  };
  g.mouseout = () => {
    g.unspread();
  };

  c.g = g;
  c.t = t;

  return c;
};

// eslint-disable-next-line no-unused-vars
function background(bgSize, inputSprite, type, forceSize) {
  const sprite = inputSprite;
  const bgContainer = new PIXI.Container();
  const mask = new PIXI.Graphics().beginFill(0x8bc5ff).drawRect(0, 0, bgSize.x, bgSize.y).endFill();
  bgContainer.mask = mask;
  bgContainer.addChild(mask);
  bgContainer.addChild(sprite);

  function resize() {
    let sp = { x: sprite.width, y: sprite.height };
    if (forceSize) sp = forceSize;
    const winratio = bgSize.x / bgSize.y;
    const spratio = sp.x / sp.y;
    let scale = 1;
    const pos = new PIXI.Point(0, 0);
    if (type === 'cover' ? (winratio > spratio) : (winratio < spratio)) {
      // photo is wider than background
      scale = bgSize.x / sp.x;
      pos.y = -((sp.y * scale) - bgSize.y) / 2;
    } else {
      // photo is taller than background
      scale = bgSize.y / sp.y;
      pos.x = -((sp.x * scale) - bgSize.x) / 2;
    }

    sprite.scale = new PIXI.Point(scale, scale);
    sprite.position = pos;
  }

  resize();

  return {
    container: bgContainer,
    doResize: resize,
  };
}
